<template>
    <a href=".">
        <img alt="UniHR Logo" class="display:block m:0|auto" height="56" src="images/logo.svg" width="224" />
    </a>
</template>
